/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type MessageDelete_message$ref = any;
export type TypeOfMessageable = "happening" | "message" | "offer" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type MessageEdit_message$ref: FragmentReference;
declare export opaque type MessageEdit_message$fragmentType: MessageEdit_message$ref;
export type MessageEdit_message = {|
  +id: string,
  +title: ?string,
  +body: ?string,
  +endDate: ?any,
  +externalUrl: ?string,
  +hasMessageable: boolean,
  +backgroundImageUrl: ?string,
  +messageableType: TypeOfMessageable,
  +messageableId: ?string,
  +mixpanelWebhook: string,
  +pushNotificationText: ?string,
  +callToAction: ?string,
  +messageDisplay: ?{|
    +title: string,
    +body: string,
    +endDate: any,
    +externalUrl: ?string,
    +backgroundImageUrl: ?string,
    +pushNotificationText: ?string,
    +callToAction: ?string,
  |},
  +$fragmentRefs: MessageDelete_message$ref,
  +$refType: MessageEdit_message$ref,
|};
export type MessageEdit_message$data = MessageEdit_message;
export type MessageEdit_message$key = {
  +$data?: MessageEdit_message$data,
  +$fragmentRefs: MessageEdit_message$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backgroundImageUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pushNotificationText",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "callToAction",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageEdit_message",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasMessageable",
      "storageKey": null
    },
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messageableType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messageableId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mixpanelWebhook",
      "storageKey": null
    },
    (v5/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageDisplay",
      "kind": "LinkedField",
      "name": "messageDisplay",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MessageDelete_message"
    }
  ],
  "type": "Message"
};
})();
// prettier-ignore
(node/*: any*/).hash = '41b33a8ea79e6dad8bd17c442b9b9b6a';

module.exports = node;
